import React, {useState, useEffect} from 'react';
import {Modal, Button} from "react-bootstrap";
import {connect} from "react-redux";

import withReactContent from 'sweetalert2-react-content';
import FormsService from "../../../services/FormsService";
import FormWrarper from "../../Forms/FormWrarper";


const rowBtnStyle = {
    "display": "block",
    "position": "absolute",
    "bottom": "30px",
    //"marginLeft": "-5px",
    //"padding": "9px 55px 10px 4px",
    "width": "100%",
    //"backgroundColor": "var(--theme-page-background)",
}

const FormsCallButtons = (props) => {

    //const [selectedForm , setSelectedForm] = useState()
    //const [demandeur, setDemandeur] = useState()
    //const [htmlData, setHtmlData] = useState()
    //const [showChoosModal, setShowChoosModal] = useState(false)
    //const [refForms, setRefForms] = useState([])
    //const [pdfannexes, setPdfAnnexes] = useState([])
    //const formService = new  FormsService();
    const [countDataRef, setCountDataRef] = useState(0);
    //const [resultCapture, setResultCapture] = useState([])
    //const modalContainer = document.body;
    /*
    let screenCaptsERP = [
        {"order": 0, "libelle": "zone_inondable","layers": [ 'cadastre:batiment', 'risque:azi_atlas_zone_inondable'],"content": '', "state": 0},
        {"order": 10, "libelle": "zone_submersion_marine","layers": [ 'cadastre:batiment', 'risque:azs_atlas_submersion_marine'],"content": '', "state": 0},
        {"order": 20, "libelle": "risque_naturel","layers": [ 'cadastre:batiment', 'risque:atlas_mouvement_terrain'],"content": '', "state": 0},
        {"order": 30, "libelle": "risque_amiante","layers": [ 'cadastre:batiment', 'risque:risque_amiante'],"content": '', "state": 0},
        {"order": 40, "libelle": "risque_argile","layers": [ 'cadastre:batiment', 'risque:argile'],"content": '', "state": 0},
        {"order": 50, "libelle": "risque_horsppr","layers": [ 'cadastre:batiment', 'risque:hors_ppr'],"content": '', "state": 0},
        {"order": 60, "libelle": "risque_inondreg","layers": [ 'cadastre:batiment', 'risque:risque_inondation_reg'],"content": '', "state": 0},
        {"order": 70, "libelle": "risque_incendie","layers": [ 'cadastre:batiment', 'risque:risque_incendie_foret'],"content": '', "state": 0},
        {"order": 80, "libelle": "risque_avalanche","layers": [ 'cadastre:batiment', 'risque:avalanche'],"content": '', "state": 0},
        {"order": 90, "libelle": "risque_mvt_terrain","layers": [ 'cadastre:batiment', 'risque:risque_mouvement_terain'],"content": '', "state": 0},
        {"order": 100, "libelle": "risque_pprt","layers": [ 'cadastre:batiment', 'risque:risque_technologique'],"content": '', "state": 0},
        {"order": 110, "libelle": "risque_seveso","layers": ['cadastre:batiment', 'risque:risque_seveso'],"content": '', "state": 0},
        {"order": 120, "libelle": "risque_minier","layers": [ 'cadastre:batiment', 'risque:risque_miniers'],"content": '', "state": 0},
        {"order": 130, "libelle": "risque_mvt_terrain_local","layers": [ 'cadastre:batiment', 'risque:risque_mvt_localise'],"content": '', "state": 0},
        {"order": 140, "libelle": "risque_sis","layers": ['cadastre:batiment', 'risque:sis_secteur_info_sols'],"content": '', "state": 0},
        {"order": 150, "libelle": "risque_peb","layers": [ 'cadastre:batiment', 'nuisance_sonore:risque_peb'],"content": '', "state": 0},
        {"order": 160, "libelle": "risque_radon","layers": [ 'cadastre:batiment', 'risque:risque_radon'],"content": '', "state": 0},
        {"order": 170, "libelle": "risque_sismique","layers": [ 'cadastre:batiment', 'risque:risque_sismique'],"content": '', "state": 0},
        {"order": 180, "libelle": "risque_termite","layers": [ 'cadastre:batiment', 'risque:risque_termite'],"content": '', "state": 0},
    ];

    useEffect(()=>{
        //console.log(htmlData)
    },[htmlData])

    */

    useEffect(()=>{
        setCountDataRef(props.listDataRef.length);
        (countDataRef && countDataRef > 0 && countDataRef < props.countTotalDataRef)?props.setDataFormIsReady(false):props.setDataFormIsReady(true);

    }, [props.listDataRef, countDataRef])

    /*
    const openForms=(e)=>{
        let htmlInfo = <FormWrarper formSelect={e} screenCapt={props.locationScreenCapt} demInfo={props.demInfo} addressBien={props.addressBien}/>
        const htmlFormAdress = `<div class="form-group">
                            <input type="text" id="address" class="form-control"  placeholder="Adresse">
                            <input type="text" id="cp" class="form-control mt-3"  placeholder="Code Postale">
                            <input type="text" id="city" class="form-control mt-3"  placeholder="Commune">
                            </div>`

        let messg = '';
        var addressBien = 'rien';
        switch(e){
            case 'dpu':
              messg =  '<div style="font-size:0.9rem;font-weight:600;" class="font-weight-bold">Quelle est l\'adresse du bien ?</div>'
              break;
            default:
              messg =  '<div style="font-size:0.9rem;font-weight:600;" class="font-weight-bold">Renseigner une adresse ? </div>'
        }
        //console.log(e);

        if(e){
            withReactContent(Swal).mixin({
                confirmButtonText: 'Suivant &rarr;',
                cancelButtonText: 'Annuler',
                showCancelButton: true,
                showConfirmButton: true,
                allowOutsideClick: false,
                progressSteps: ['1','2']
            }).queue(
                [
                    {
                    title: messg,
                    html: htmlFormAdress,
                    imageHeight: 830,
                    showCloseButton: true,
                    confirmButtonColor: '#e57f13',
                    confirmButtonText: 'suivant',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    preConfirm : ()=>{

                        const address = Swal.getPopup().querySelector('#address').value
                        const cp = Swal.getPopup().querySelector('#cp').value
                        const city = Swal.getPopup().querySelector('#city').value

                        if ( e=='dpu'&& (!address|| !cp || !city)) {
                            Swal.showValidationMessage(`Merci de renseigner une adresse pour le bien`)
                        }

                        addressBien = (address)?address:' ';
                        addressBien += ' '+(cp)?cp:' ';
                        addressBien += ' '+(city)?city:' ';

                        props.saveAdressBien(addressBien);
                        return { address: address, cp: cp, city: city}
                     }
                    },
                    {
                        title: 'Visualisation de vos données',
                        html: htmlInfo,
                        imageHeight: 830,
                        showCloseButton: false,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        confirmButtonColor: '#17eebc',
                        confirmButtonText: 'Valider',
                        preConfirm : ()=>{
                            //// This for capture html values updated
                            $('#eu-form-demref').remove();
                                $('#eu-demref').removeClass('d-none');
                                let htmlref = document.getElementById('form-dem-data').innerHTML;
                                setHtmlData(htmlref);
                                return new Promise(function (resolve) {
                                    resolve(htmlref);
                            })
                        },
                        didOpen(popup) {
                            // this for auto close popup with html values
                            Swal.getConfirmButton().click();
                        }
                    },
            ]
            ).then((result)=>{

                if(result.value && result.value.length > 1){
                    //console.log(result);
                    $('.swal2-popup').css('color', '#d6d6d6');
                    Swal.fire({
                        title: '<p style="color:#FFFFFF;">Formulaire</p>',
                        html: '<p style="color:#FFFFFF;">Sauvegarde de vos données !!</p>',
                        background: ' #303a3f',
                        width: '19rem',
                        showCancelButton: false,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        backdrop: true,
                        allowEscapeKey: false,
                    })
                    Swal.showLoading();

                    const params = {
                        //'entity': props.userSubscription,
                        'entity': props.currentEntity.name,
                        'doctype': (e=='rnu')?'NRU':String(e).toUpperCase(),
                        'insee_com': props.currentCom,
                        'label_com': result.value[0].city,
                        'terr_addr' : result.value[0].address+' '+result.value[0].cp,
                        'terr_code_base':props.currentParcelle[0],
                        'terr_code_all': props.currentParcelle.join(','),
                        'entity_id':props.currentEntity.id,
                        'dem_name': (demandeur && demandeur.name)?demandeur.name:props.meName,
                        'dem_addr': (demandeur && demandeur.address)?demandeur.address:props.currentEntity.address,
                        'dem_city': (demandeur && demandeur.city)?demandeur.city:props.currentEntity.city,
                        'dem_cp': (demandeur && demandeur.cp)?demandeur.cp:props.currentEntity.cp,
                        'dem_phone': (demandeur && demandeur.phone)?demandeur.phone:props.currentEntity.phone,
                        'dem_email': (demandeur && demandeur.email)?demandeur.email:props.meEmail,
                        'dem_raison_sociale': props.currentEntity.name,
                        'pdf_annexes' : pdfannexes,
                    }

                    axios.post('/Api/Form_ref', params)
                        .then(result1=>{
                            if(result1.data && result1.data.id){
                                if(e=='erp'){
                                    const params = {
                                        'key_parcelles' : props.currentParcelles,
                                        'form_types'    : ['peb','erp', 'ial'],
                                        'com_label'     : props.currentComLabel,
                                        'ref_form_id'   : result1.data.id,
                                    }

                                    axios.post('/Api/Form_data/buildpdf', params)
                                        .then(result3=>{
                                            //console.log(result3.data)
                                            setPdfAnnexes(result3.data)
                                            recordScreenCapture(0, result, result1)
                                        }).catch(err => {console.log(err)})
                                }else{
                                    recordResult(result, result1) // store data for  other than erp
                                }
                            }else{
                                $('.swal2-popup').css('color', '#d6d6d6');
                                Swal.fire({
                                    title: '<p style="color:#FFFFFF;">Formulaire</p>',
                                    html: '<p style="color:#FFFFFF;">Désolé. Vos données n\'ont pas été enregistrées !!</p>',
                                    background: ' #303a3f',
                                    width: '19rem',
                                    showCancelButton: false,
                                    showConfirmButton: true,
                                    confirmButtonText: 'Fermer',
                                    confirmButtonColor: '#e57f13',
                                })
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            Swal.close()
                            resetForm()
                        })
                }else{
                    resetForm()
                }
            })
        }
    }

    const recordScreenCapture = (index, result, result1)=>{
        formService.captureScreenLocation(null, 72, 3, screenCaptsERP[index].layers).then((res) => {
            screenCaptsERP[index].content = res;
            axios.post('/Api/Form_data/storeScreenCapture', {'capts':[screenCaptsERP[index]],'form_ref_id':result1.data.id}).then(resultCapt=>{})
            if(index==screenCaptsERP.length-1){
                const refMap = $('#map').data('map');
                formService.prepareMap(refMap);
                recordResult(result, result1)
            }else{
                index ++;
                recordScreenCapture(index, result, result1)
            }
        }).catch(err=>{console.log(err)});
    }

    const recordResult=(result, result1)=>{

        const formparams = {
            'form_ref_id': result1.data.id,
            'data_values': props.dataValues,
            'img_ref': (selectedForm=='nru' || selectedForm=='ru')?props.locationScreenCapt:'empty',
            'form_links':props.formLinks,
            'html_content': result.value[1]
        }

        axios.post('/Api/Form_data/store', formparams)
            .then(result2=>{
                if(result2.data &&  result2.data.formData && typeof result2.data.formData == 'number' )
                {
                    //console.log(result2.data)
                    $('.swal2-popup').css('color', '#d6d6d6');
                    $('.swal2-content').css('font-size', '0.90rem');

                    Swal.fire({
                        title: '<p style="color:#FFFFFF;">Formulaire</p>',
                        html: '<p style="color:#FFFFFF;">Merci, vos données ont bien été enregistrées !!</p>' +
                            '<br/>' +
                            '<span style=color:#FFFFFF;">Retrouvez votre demande dans votre tableau de bord</span>',
                        background: ' #303a3f',
                        width: '20rem',
                        showCancelButton: true,
                        showConfirmButton: true,
                        confirmButtonText: 'Tableau de bord <i class="bi bi-grid-fill"></i>',
                        cancelButtonText: 'Fermer <i class="bi bi-x-square"></i>',
                        confirmButtonColor: '#e57f13',
                        cancelButtonColor: '#6e6e6e',

                    }).then((result)=>{
                        if(result.isConfirmed) {
                            props.showcurrentSection('resources');
                            Swal.close();
                        }else{
                            Swal.close();
                        }
                    })
                }
            }).catch(err=>{
            console.log(err);
            Swal.close()
            $('.swal2-popup').css('color', '#d6d6d6');
            Swal.fire({
                title: '<p style="color:#FFFFFF;">Formulaire</p>',
                html: '<p style="color:#FFFFFF;">Désolé. Nous n\'avons pas pue enregistrer vos données !!</p>',
                background: ' #303a3f',
                width: '19rem',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Fermer',
                confirmButtonColor: '#e57f13',
            })
            resetForm()
        })
    }

    const preparForm=(e)=>{
        setShowChoosModal(false)
        if((props.currentEntity?.genre.slug==="collective") || (props.userSubscription && props.userSubscription !=null) ){
            props.toggleLayerStack()
            setSelectedForm(e)

            if( e === 'cua' || e === 'cub'){
                openForms(e)// without screenCapture !
            }else{
                    props.initForm(e)
                $('.swal2-popup').css('color', '#d6d6d6');
                Swal.fire({
                    title: '<p style="color:#FFFFFF;">Formulaire</p>',
                    html: '<p style="color:#FFFFFF;">Préparation de vos données en cours, merci de ne pas rafraîchir votre affichage...</p>',
                    background: ' #303a3f',
                    width: '15rem',
                    showCancelButton: false,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    backdrop: false,
                    allowEscapeKey: false,
                })
                Swal.showLoading()
            }
        }else{
            Swal.fire({
                html: '<p style="color:#FFFFFF;"> Désolé. <br/>Votre statut actuel ne vous permet pas d\accéder à ces fonctionnalités !</p>',
                iconHtml: '<i class="bi bi-shield-lock"></i>',
                iconColor: '#ac3a05',
                background: ' #303a3f',
                showConfirmButton: false,
                cancelButtonText: 'Fermer'
            })
        }
    }


    useEffect(()=>{
        if(props.locationScreenCapt){
            Swal.close();
            openForms(selectedForm)
        }
    }, [props.locationScreenCapt])


    useEffect(()=>{
        setDemandeur(props.demInfo)
    },[props.demInfo])


    const resetForm=()=>{
        props.resetForm()
        props.resetScreenCapt()
    }

     */



    const handleOpenForm = (e)=>{
        /*
        switch(e){
            case 'collective':
             setRefForms([
                 {'label': 'Renseignement d\'Urbanisme (RU)','code': 'ru'},
                 {'label': 'Certificat d\'Urbanisme (A) (CUA)','code': 'cua'},
                 {'label': 'Certificat d\'Urbanisme (B) (CUB)','code': 'cub'},
             ])

                break;
            case 'pro':
                setRefForms([
                    {'label': 'Droit de Préemption Urbanisme (DPU)','code': 'dpu'},
                    {'label': 'Note de renseignement d\'Urbanisme (NRU)','code': 'nru'},
                    {'label': 'Note de renseignement d\'Urbanisme - professionnels  (NRU)','code': 'nrupro'},
                    {'label': 'Note de renseignement d\'Urbanisme - Experts (NRU)','code': 'nruexp'},
                    {'label': 'État des Risques et Pollution (ERP)','code': 'erp'},
                    {'label': 'Plan d\'aménagement et de développement durable de la Corse (PADDUC)','code': 'padduc'},
                ])
                break;
            default:
                return;
        }
        setShowChoosModal(true)

         */
    }


    return (
            <div style={{"position": "absolute", "bottom":"60px", "width":"100%"}}>
                {(countDataRef && countDataRef > 0 && countDataRef < props.countTotalDataRef) ?
                    <div className={'row d-flex flex-sm-row flex-column'} style={rowBtnStyle}>
                        <div className="col-12">
                            <a href={'#'}
                               className={'btn btn-block btn-lg ' }
                               >
                                <div className={"mb-1"}>
                                    <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                    <span className="ml-2" style={{"fontSize": "0.7rem", "color": "var(--primary)"}}>Chargement...</span>
                                </div>
                                <div className="progress" style={{"height": "7px"}}>
                                    <div className="progress-bar" style={{
                                        "minWidth": "20px",
                                        "fontSize": "0.45rem",
                                        "backgroundColor": "#08f1d5",
                                        "width": Math.round((100 / props.countTotalDataRef) * countDataRef) + "%"
                                    }}>
                                        {Math.round((100 / props.countTotalDataRef) * countDataRef)}%
                                    </div>
                                </div>

                            </a>
                        </div>
                    </div>
                    : null // avant bouton sur handleOpenForm("pro")
                }

                {/*
                <Modal
                    show={showChoosModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={()=>setShowChoosModal(false)}
                    centered
                    style={{"color": "#2b2b2b"}}
                >

                    <Modal.Header closeButton>
                        <Modal.Title>Formulaires</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>Merci de choisir un type de formulaire</h5>
                        {
                            refForms.map((item,index)=>{
                                return ( <button key={index} className={"btn btn-outline-primary btn-block"} onClick={()=>preparForm(item.code)}>{item.label}</button> )
                            })
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={(e)=>setShowChoosModal(false)}>
                            Annuler
                        </Button>
                    </Modal.Footer>
                </Modal>
                */}
            </div>
    );
};

const mapStateToProps = state => {
    return {
        //currentCom : state.MapReducer.currentCom,
       //currentComLabel : state.MapReducer.currentComLabel,
        //currentParcelle : state.MapReducer.currentParcelle,
        //currentEntity: state.MeReducer.entity,
        //meName: state.MeReducer.name,
        //meEmail: state.MeReducer.email,
        //demInfo : state.FormsReducer.demandeur,
        //userSubscription : state.MeReducer.subscription,
        //currentParcelles : state.MapReducer.currentParcelle,
        //locationScreenCapt : state.MapReducer.locationScreenCapt,
        //dataValues: state.FormsReducer.formData,
        //addressBien: state.FormsReducer.addressBien,
        //formLinks : state.FormsReducer.formLinks,
        countTotalDataRef : state.FormsReducer.countTotalDataRef,
        listDataRef: state.FormsReducer.listDataRef,

    }
}

const mapDispatchTProps = dispatch => {
    return {
        toggleLayerStack: () => dispatch( {type: 'TOGGLE_LAYERS_STACK'}),
        showTabPanel: (e)=> dispatch({type: 'TOGGLE_PANEL_TAB', data:{currentTab: e}}),
        initForm: (e) => dispatch( {type: 'INIT_FORM', data: {formRef : e}}),
        resetForm: (e) => dispatch( {type: 'RESET_FORM'}),
        resetScreenCapt: () => dispatch( {type: 'RESET_SCREEN_CAPT'}),
        saveFomData: (e) => dispatch({type: 'SAVE_FORM_DATA', data:{"form_ref_id": e}}),
        saveAdressBien: (e) => dispatch({type: 'SAVE_ADDRESS_BIEN', data: e}),
        showcurrentSection: (e) => dispatch( {type: 'SHOW_CURRENT_SECTION', data:e}),
        setDataFormIsReady: (e) => dispatch( {type: 'DATA_FORM_IS_READY', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(FormsCallButtons);
